import axios from 'axios'
import firebase from 'firebase/app';

import {
    FETCH_ALL_DISCOUNTS, LOAD_ALL_DISCOUNTS, ERROR_ALL_DISCOUNTS,
} from './Types';


export const getAllDiscountTypes = () => {

    return (dispatch, getState, { getFirebase }) => {
        const firebase = getFirebase();
        firebase.auth().currentUser.getIdToken().then((token) => {
            dispatch({
                type: LOAD_ALL_DISCOUNTS,
                payload: 'loading'
            })

            const url = "/DiscountType/getAllDiscountTypes"
            const config = {
                headers: {
                    'content-type': 'application/x-www-form-urlencoded; charset=utf-8',
                    'X-Authorization-Firebase': token
                }
            }
            axios.get(url, config).then((res) => {
                dispatch(
                    {
                        type: FETCH_ALL_DISCOUNTS,
                        payload: res.data
                    }
                )
            }).catch((Error) => {
                dispatch({
                    type: ERROR_ALL_DISCOUNTS,
                    payload: Error.message
                })
            })
        })
    }
}
